<template>
  <div class="mg-mini-pagination">
    <div class="page-button" :class="{ disabled: disabledPre }" @click="() => handlePageChange(-1)">
      <i class="iconfont mg-icon_shangyiye" />
    </div>
    <el-popover :disabled="disabled" ref="popover" placement="bottom" width="120" trigger="hover" v-model="visible">
      <span class="total-size">{{ $MGUI.i18n.t('共') }} {{ total }} {{ $MGUI.i18n.t('条') }}</span>
      <div class="jump-page">
        <span>{{ $MGUI.i18n.t('前往') }}</span>
        <el-input size="small" style="width: 50px" v-model.number="jumpPage" @keyup.enter.native="handleConfirm" />
        <span>{{ $MGUI.i18n.t('页') }}</span>
      </div>
    </el-popover>
    <span class="page-box" v-popover:popover>{{ page || 1 }}/{{ totalPage || 1 }}</span>
    <div class="page-button" :class="{ disabled: disabledNext }" @click="() => handlePageChange(1)">
      <i class="iconfont mg-icon_xiayiye" />
    </div>
  </div>
</template>

<script>
  export default {
    props: {
      page: Number,
      totalPage: Number,
      total: {
        type: Number,
        default: 0,
      },
    },
    data() {
      return {
        visible: false,
        jumpPage: this.page,
      }
    },
    computed: {
      disabled() {
        return this.totalPage <= 0
      },
      disabledPre() {
        return this.page <= 1
      },
      disabledNext() {
        return this.page >= this.totalPage
      },
    },
    methods: {
      handlePageChange(page) {
        page = this.page + page
        if (isNaN(page)) {
          this.$emit('page-change', 1)
          return
        }
        if (page < 1 || page > this.totalPage) return
        this.$emit('page-change', page)
      },
      handleConfirm() {
        if (this.jumpPage > 0 && this.jumpPage <= this.totalPage) {
          this.visible = false
          if (this.jumpPage !== this.page) {
            this.handlePageChange(this.jumpPage - this.page)
          }
        }
      },
    },
  }
</script>
<style lang="scss">
  .jump-page {
    display: flex;
    align-items: center;
    justify-content: space-around;
  }
  .total-size {
    display: block;
    font-size: 13px;
    color: rgba(0, 0, 0, 0.65);
    padding: 0px 10px 8px 10px;
  }
</style>
<style lang="scss" scoped>
  .mg-mini-pagination {
    width: var(--mg-mini-pagination-width);
    min-width: var(--mg-mini-pagination-width);
    height: var(--mg-op-btn-height);
    line-height: var(--mg-op-btn-height);
    border: 1px solid rgba(37, 42, 61, 0.2);
    border-radius: 4px;
    box-sizing: border-box;
    display: flex;
    align-items: center;
    justify-content: space-between;
    flex-shrink: 0;
    font-size: 12px;
    font-weight: 500;
    margin-left: 10px;
    .page-button {
      width: 32px;
      padding: 0;
      height: 100%;
      display: flex;
      align-items: center;
      justify-content: center;
      cursor: pointer;
      &.disabled {
        opacity: 0.3;
        pointer-events: none;
      }
    }

    .page-box {
      flex: 1;
      height: 100%;
      border-left: 1px solid rgba(37, 42, 61, 0.2);
      border-right: 1px solid rgba(37, 42, 61, 0.2);
      padding: 0 8px;
      color: #252a3d;
      display: inline-flex;
      align-items: center;
      justify-content: center;
      white-space: nowrap;
      word-break: keep-all;
    }
  }
</style>
